export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14778.52f36f75.jpg";